export default "__VITE_ASSET__Bhz1aJwe__"